<template>
  <div :key="key" class="dashboard-chart">
    <h4>Plazos de Pago</h4>
    <!-- :separator-step="parseInt(indicadorPlazosObjetivo)" -->
    <vue-svg-gauge
    :start-angle="-110"
    :end-angle="110"
      :value="indicadorPjeObjetivo"
      :min="indicadorPlazosMin"
      :max="indicadorPlazosMax"
      :separator-step="0"
      :gauge-color="indicadorPlazosColor"
      :scale-interval="10"/>
    <div class="dashboard-chart-text">
      <p>Plazo Objetivo: {{ indicadorPlazosObjetivo }} días</p>
      <p>Plazo Actual: {{ indicadorPlazosActual }} días</p>
      <p v-if="indicadorPlazosObjetivo != 0">Pje Actual: {{ indicadorPjeObjetivo | numero(2, true) }} %</p>
      <p v-if="indicadorPlazosObjetivo == 0">Pje Actual: -- %</p>
      <!-- <p>Plazo Objetivo: {{ indicadorPlazosObjetivo | numero(2, true) }} días</p>
      <p>Plazo Actual: {{ indicadorPlazosActual | numero(2, true) }} días</p> -->
      <p class="description">{{ indicadorPlazosDescripcion }}</p>
      <p v-if="verDatosPlazosProveedores" 
        class="link" 
        @click.stop="exportarPlazosProveedoresComprobantes"><i class="fa fa-file-excel-o"></i>Exportar Datos</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';

export default {
  components: {
    VueSvgGauge,
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorPlazosActual: 0,
      indicadorPlazosObjetivo: parseInt(0),
      indicadorPlazosMin: 0,
      indicadorPlazosMax: 100,
      indicadorPlazosColor:  [ { offset: 0, color: '#E46651' }, { offset: 100, color: '#E46651' } ],
      indicadorPlazosDescripcion: '',
      indicadorPjeObjetivo: 0,

      verDatosPlazosProveedores: true
    }
  },
  created() {
  },
  methods: {
    getIndicador() {
      this.$store.dispatch('resultadosAdministracion/getIndicadorPlazosProveedores')
        .then(() => {
          let indicador = this.$store.getters['resultadosAdministracion/indicadorPlazosProveedores']

          this.indicadorPlazosActual = +(Math.round(indicador.plazoActual + "e+2")  + "e-2");
          this.indicadorPlazosObjetivo = parseFloat(indicador.plazoObjetivo);
          this.indicadorPlazosMax = indicador.plazoActual > 100 ? indicador.plazoActual : 100;
          this.indicadorPlazosDescripcion = indicador.indicadorPeriodo ? indicador.indicadorPeriodo.trim() : '';
          this.indicadorPjeObjetivo = parseFloat(indicador.pjeObjetivo);

          // if (parseFloat(this.indicadorPjeObjetivo) >= parseFloat(110)) {
          //   this.indicadorPlazosColor = [{ offset: 0, color: this.rosa }, { offset: 100, color: this.rosa }];
          // } else 
          if (parseFloat(this.indicadorPjeObjetivo) >= parseFloat(100)) {
            this.indicadorPlazosColor = [{ offset: 0, color: this.verde }, { offset: 100, color: this.verde }];
          } else if (parseFloat(this.indicadorPjeObjetivo) > parseFloat(50)) {
            this.indicadorPlazosColor = [{ offset: 0, color: this.amarillo }, { offset: 100, color: this.amarillo }];
          }

          this.$emit('inicializado');
        })
        .finally(() => this.key++);
    },
    cancelar() {
      this.$store.dispatch('resultadosAdministracion/cancelarIndicadorPlazosProveedores');
    },
    exportarPlazosProveedoresComprobantes() {
      this.showSpinner();
      this.$store.dispatch('resultadosAdministracion/getIndicadorPlazosProveedoresComprobantes')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptComprobantes = this.$store.getters['resultadosAdministracion/resultadosIndicadorPlazosProveedoresComprobantes'];

          if (rptComprobantes) {
            if (rptComprobantes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            this.exportXLSResumenPlazosProveedores(rptComprobantes);
          } else {
            console.log('No hay datos para exportar.');
            // this.showErrorMsj('No hay datos para exportar.')
          }
        })
        .catch(error => {
          console.log(error);
          // this.showErrorMsj(error)
        })
        .finally(() => this.hideSpinner());
    }
  }
}
</script>

<style>
</style>


